import { render } from "./ComingSoon.vue?vue&type=template&id=177a8d41"
import script from "./ComingSoon.vue?vue&type=script&lang=js"
export * from "./ComingSoon.vue?vue&type=script&lang=js"

import "./ComingSoon.vue?vue&type=style&index=0&id=177a8d41&lang=scss"
script.render = render

export default script